import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
    getFormData,
    handleFormErrors,
    handleFormSubmit,
    handleInputChange,
} from "../services/formServices";
import http from "../services/httpServices";
import page from "../services/pageServices";

import InputField from "../components/form/elements/InputField";
import InputIcon from "../components/form/elements/InputIcon";
import SigningForm from "../components/form/singingForm/SigningForm";

// import loginPicture from "../assets/join-us.png";
import modal from "../services/modalServices";

import loginPageIcon from "../assets/komet-assets/joinus.png";
import { useLanguage } from "../context/LanguageContext";

const JoinUsHome = () => {
    const { language } = useLanguage(); // Language Context Hook
    const translations = {
        title: {
            en: "Join Komet Institut Team!",
            ar: "انضم إلى فريق معهد كوميت!",
            de: "Treten Sie dem Komet Institut Team bei!",
        },
        description: {
            en: "Fill out your details now to join our team!",
            ar: "سجل بياناتك الآن للإنضمام إلى فريقنا!",
            de: "Füllen Sie jetzt Ihre Daten aus, um unserem Team beizutreten!",
        },
        buttonTitle: {
            en: "Join Now",
            ar: "انضم الآن",
            de: "Jetzt beitreten",
        },
        formLabels: {
            job: { en: "Job Position", ar: "الوظيفة", de: "Stellenbezeichnung" },
            firstName: { en: "First Name", ar: "الإسم الأول", de: "Vorname" },
            secondName: { en: "Middle Name", ar: "الإسم الثاني", de: "Zweiter Name" },
            thirdName: { en: "Third Name", ar: "الإسم الثالث", de: "Dritter Name" },
            lastName: { en: "Last Name", ar: "الإسم الأخير", de: "Nachname" },
            phone: { en: "Phone Number", ar: "رقم الهاتف", de: "Telefonnummer" },
            email: { en: "Email", ar: "البريد الإلكتروني", de: "E-Mail" },
            government: { en: "Governorate", ar: "المحافظة", de: "Bundesland" },
            expectedSalary: {
                en: "Expected Salary",
                ar: "الراتب المتوقع",
                de: "Erwartetes Gehalt",
            },
            whatValue: {
                en: "What will you add to Komet?",
                ar: "ماذا ستضيف لكوميت؟",
                de: "Was bringen Sie zu Komet?",
            },
            address: { en: "Address", ar: "العنوان", de: "Adresse" },
            workExperience: { en: "Work Experience", ar: "الخبرة العملية", de: "Berufserfahrung" },
            nationalIdCopy: {
                en: "National ID Copy",
                ar: "صورة البطاقة الشخصية",
                de: "Personalausweis-Kopie",
            },
            resume: {
                en: "Resume / Portfolio",
                ar: "السيرة الذاتية / البورتفوليو",
                de: "Lebenslauf / Portfolio",
            },
            facebook: {
                en: "Facebook Link (Optional)",
                ar: "رابط الفيسبوك (اختياري)",
                de: "Facebook-Link (Optional)",
            },
            instagram: {
                en: "Instagram Link (Optional)",
                ar: "رابط الإنستجرام (اختياري)",
                de: "Instagram-Link (Optional)",
            },
            otherSocialMedia: {
                en: "Personal Website / Portfolio / Behance (Optional)",
                ar: "رابط موقعك الشخصي / بورتفوليو / بيهانس او غيره (اختياري)",
                de: "Persönliche Website / Portfolio / Behance (Optional)",
            },
        },
    };
    const [user, setUser] = useState({
        first_name: "",
        second_name: "",
        third_name: "",
        last_name: "",
        phone: "",
        email: "",
        national_id_copy: "",
        resume: "",
        expected_salary: "",
        what_value: "",
        candidate_type: "",
        address: "",
        work_experience: "",
        government_id: "",
    });

    const [errors, setErrors] = useState({});

    const [isLoading, setIsLoading] = useState(false);

    const [candidateTypes, setCandidateTypes] = useState([]);
    const [governments, setGovernments] = useState([]);

    const getGovernments = async () => {
        try {
            const { data: response } = await http.get("api/governments");
            setGovernments(response);
        } catch (error) {
            // console.log(error);
        }
    };

    const getCadidateTypes = async () => {
        try {
            const { data: response } = await http.get("api/candidate_types");
            setCandidateTypes(response);
        } catch (error) {
            // console.log(error);
        }
    };

    useEffect(() => {
        getCadidateTypes();
        getGovernments();
    }, []);

    const inputFields = [
        {
            id: "candidate_type",
            placeholder: translations.formLabels.job[language],
            type: "select",
            options: candidateTypes,
            icon: <InputIcon icon="ant-design:usergroup-add-filled" />,
            className: "lg:col-span-2",
        },
        {
            id: "first_name",
            placeholder: translations.formLabels.firstName[language],
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
        },
        {
            id: "second_name",
            placeholder: translations.formLabels.secondName[language],
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
        },
        {
            id: "third_name",
            placeholder: translations.formLabels.thirdName[language],
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
        },
        {
            id: "last_name",
            placeholder: translations.formLabels.lastName[language],
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
        },
        {
            id: "phone",
            placeholder: translations.formLabels.phone[language],
            icon: <InputIcon icon="ant-design:phone-filled" />,
        },
        {
            id: "expected_salary",
            placeholder: translations.formLabels.expectedSalary[language],
            icon: <InputIcon icon="ant-design:dollar-circle-filled" />,
        },
        {
            id: "what_value",
            type: "textarea",
            placeholder: translations.formLabels.whatValue[language],
            icon: <InputIcon icon="ant-design:bulb-filled" />,
            className: "lg:col-span-2",
        },
        {
            id: "government_id",
            placeholder: translations.formLabels.government[language],
            type: "select",
            options: governments,
            className: "lg:col-span-2",
        },

        {
            id: "address",
            placeholder: translations.formLabels.address[language],
            icon: <InputIcon icon="ant-design:home-filled" />,
        },
        {
            id: "email",
            placeholder: translations.formLabels.email[language],
            icon: <InputIcon icon="ant-design:mail-filled" />,
        },
        {
            id: "work_experience",
            type: "textarea",
            placeholder: translations.formLabels.workExperience[language],
            className: "lg:col-span-2",
        },
        {
            id: "national_id_copy",
            placeholder: translations.formLabels.nationalIdCopy[language],
            type: "file",
        },
        {
            id: "resume",
            placeholder: translations.formLabels.resume[language],
            type: "file",
        },
        {
            id: "facebook_link",
            placeholder: translations.formLabels.facebook[language],
            icon: <InputIcon icon="ant-design:facebook-filled" />,
            isRequired: false,
        },
        {
            id: "instagram_link",
            placeholder: translations.formLabels.instagram[language],
            icon: <InputIcon icon="ant-design:instagram-filled" />,
            isRequired: false,
        },
        {
            id: "other_social_media",
            placeholder: translations.formLabels.otherSocialMedia[language],
            icon: <InputIcon icon="bytesize:portfolio" />,
            isRequired: false,
            className: "lg:col-span-2",
        },
    ];
    const pageTitles = {
        en: "Join the Komet Institut Team!",
        ar: "انضم إلى فريق معهد كوميت!",
        de: "Treten Sie dem Komet Institut Team bei!",
    };
    useEffect(() => {
        const currentTitle = page.getCurrentTitle();
        page.setTitle(pageTitles[language] || pageTitles.ar);
        return () => {
            page.setTitle(currentTitle);
        };
    }, []);

    const handleSubmit = (e) => {
        handleFormSubmit(e, setIsLoading, setErrors, submitFormResponse);
    };

    const navigate = useNavigate();

    const redirect = (certainPath = false) => {
        navigate("/home");
    };
    const jobApplicationMessages = {
        en: {
            title: "Application Submitted",
            text: "Your job application has been submitted. It will be reviewed, and we will contact you soon.",
        },
        ar: {
            title: "تم ارسال طلب التوظيف",
            text: "تم ارسال طلب التوظيف الخاص بك. سيتم المراجعة والتواصل معك قريبًا.",
        },
        de: {
            title: "Bewerbung eingereicht",
            text: "Ihre Bewerbung wurde eingereicht. Sie wird überprüft, und wir werden uns bald bei Ihnen melden.",
        },
    };
    const submitFormResponse = async () => {
        try {
            await http.get("/sanctum/csrf-cookie");
            let toSendUser = { ...user };
            toSendUser["phone"] = parseInt(user["phone"]);
            console.log(toSendUser);
            toSendUser = getFormData(toSendUser);
            console.log(toSendUser);
            await http.post("api/form_responses", toSendUser);
            modal.message({
                title: jobApplicationMessages[language]?.title || jobApplicationMessages.ar.title,
                text: jobApplicationMessages[language]?.text || jobApplicationMessages.ar.text,
                callback: redirect,
            });
        } catch ({ response }) {
            handleFormErrors(response, setIsLoading, setErrors, true);
        }
    };

    return (
        <div className={`negative-nav-margin gap-10 space-y-7 ${language !== "ar" ? "en" : ""}`}>
            <SigningForm
                headTitle={translations.title[language]}
                headIcon={loginPageIcon}
                layout="Glassmorphism"
                description={translations.description[language]}
                onSubmit={handleSubmit}
                fields={
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-6">
                        {inputFields.map((input, index) => (
                            <InputField
                                key={index}
                                onChange={handleInputChange}
                                data={user}
                                setData={setUser}
                                errors={errors}
                                {...input}
                            />
                        ))}
                    </div>
                }
                color="cyan"
                secondaryColor="cyan"
                buttonTitle={translations.buttonTitle[language]}
                isLoading={isLoading}
            />
        </div>
    );
};

export default JoinUsHome;
